import { doc, updateDoc, Timestamp } from 'firebase/firestore';
import { db } from '../../../config';
import { DictionaryColumnMapping } from '../../../../../types/dictionary';

interface UpdateDictionaryMappingParams {
  dictionaryId: string;
  mappingId: string;
  patternId?: string;
  patternName?: string;
  searchItemId?: string;
  searchItemLabel?: string;
  searchCsvColumn?: string;
  columnMappings?: DictionaryColumnMapping[];
}

export const updateDictionaryMapping = async (
  params: UpdateDictionaryMappingParams,
): Promise<void> => {
  const mappingRef = doc(
    db,
    'dictionaries',
    params.dictionaryId,
    'dictionary_mappings',
    params.mappingId,
  );

  const updateData: Record<string, string | DictionaryColumnMapping[] | Timestamp> = {
    updated_at: Timestamp.now(),
  };
  if (params.patternId !== undefined) updateData.pattern_id = params.patternId;
  if (params.patternName !== undefined) updateData.pattern_name = params.patternName;
  if (params.searchItemId !== undefined) updateData.search_item_id = params.searchItemId;
  if (params.searchItemLabel !== undefined) updateData.search_item_label = params.searchItemLabel;
  if (params.searchCsvColumn !== undefined) updateData.search_csv_column = params.searchCsvColumn;
  if (params.columnMappings !== undefined) updateData.column_mappings = params.columnMappings;

  await updateDoc(mappingRef, updateData);
};
